import React from 'react';
import getConfig from 'next/config';

import {Tenant} from '~/src/utilities/constants/tenant';

import css from '~/src/css/global.module.scss';

const {publicRuntimeConfig: config} = getConfig();

const ShareWhatsApp = ({title}) => (
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        {title && <title>{title}</title>}
        <path
            d="M11.183 0C5.219 0 .367 4.852.367 10.817c0 1.886.493 3.74 1.428 5.371L.02 21.518a.365.365 0 00.44.47l5.819-1.53a10.846 10.846 0 004.905 1.175C17.148 21.633 22 16.781 22 10.817 22 4.852 17.148 0 11.183 0zm5.47 15.387l-.554.556c-.701.702-1.483 1.057-2.324 1.057-1.134 0-2.356-.648-3.632-1.925l-3.218-3.22c-1.007-1.007-1.626-1.985-1.84-2.908-.258-1.12.069-2.146.973-3.05l.555-.556a1.196 1.196 0 011.382-.209c.84.446 1.711 1.904 1.808 2.068.174.306.228.622.152.893a.818.818 0 01-.375.49c-.255.213-.554.48-.607.547-.32.473-.284.838.13 1.25l2.513 2.517c.417.416.774.45 1.255.125.063-.05.33-.349.543-.604a.828.828 0 01.738-.408c.208 0 .429.063.64.183.168.099 1.626.97 2.07 1.811a1.17 1.17 0 01-.208 1.383z"
            fill={config.tenantId === Tenant.LEMATIN ? css.colorTango : css.accentColor}
        />
    </svg>
);

export default ShareWhatsApp;
